<template>
    <div class="pr-4">
        <header class="mb-2 flex w-full justify-between">
            <div class="text-sm">{{$t('GROUP_BOTTLE_LABEL', {bottle: bottleIndex + 1})}}</div>
            <button
                v-if="bottleIndex !== 0"
                class="text-red-800 underline text-sm"
                @click="removeBottle(bottleIndex)"
            >{{$t('GROUP_REMOVE')}}</button>
        </header>

        <input
            v-for="(line, lineIndex) in lines"
            v-bind:key="lineIndex"
            :value="getLineValue(lineIndex)"
            class="border rounded border-gray-300 p-2 w-full px-3 mb-2 text-[16px]"
            @input="updateText(bottleIndex, lineIndex, $event.target.value)"
        />
    </div>
</template>

<script>
    export default {
        props: {
            lines: {
                type: Array,
            },
            bottleIndex: {
                type: Number,
            },
        },
        methods: {
            /**
            * Get the value for the line, depends if it's a primary line or not
            */
            getLineValue(lineIndex) {
                const line = this.lines[lineIndex];
                if (line && line.placement) {
                    // Line is a placement
                    return line.component.custom['personalization-text'];
                }
                // Line is a string
                return line;
            },
            /**
             * Update the text for the primary bottle / text placements
             */
            updateText(bottleIndex, lineIndex, newText) {
                this.$emit('update-text', bottleIndex, lineIndex, newText);
            },
            removeBottle(bottleIndex) {
                this.$emit('remove-bottle', bottleIndex);
            },
        },
    };
</script>
